import {
  ChangeDetectorRef,
  Component,
  computed,
  DOCUMENT,
  ElementRef,
  Inject,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
  signal,
  viewChild,
} from '@angular/core';
import { distinctUntilChanged, map, Subscription, take, filter } from 'rxjs';
import { RedeemWindow } from '../../core/services/redeem-window';
import { Router } from '@angular/router';
import { MmssPipe } from '../../shared/utils/mmss-pipe';
import { NgClass } from '@angular/common';
import { QRCodeComponent } from 'angularx-qrcode';
import { MerchantContext } from '../../core/services/merchant-context';
import { MerchantEnum } from '../redeem/redeem';

@Component({
  selector: 'app-showcode',
  // imports: [MmssPipe, NgClass, QRCodeComponent],
  host: { class: 'flex flex-col shadow-[0px_0px_12px_0px_rgba(0,0,0,0.16)]' },
  template: `
    <div class="p-4">
      <!-- <h1 class="text-2xl font-bold">Heading</h1>
      <p class="text-sm text-gray-500">Subheading</p>
      <hr class="my-6 border-gray-200" />
      <div class="flex gap-2 bg-[#F1F1F1] p-1 ">
        @for (tab of tabs; track tab.value) {
          <button
            [ngClass]="{ 'bg-white': tab.value === selectedTab() }"
            class="px-4 py-2 w-full cursor-pointer transition-all duration-300"
            (click)="onSelectTab(tab.value)"
          >
            {{ tab.label }}
          </button>
        }
      </div>
      <div class="flex items-center justify-center mt-5">
        @if (selectedTab() === 'qrcode') {
          <qrcode [qrdata]="code() || ''" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
        } @else {
          <div class="mt-10">
            <canvas #barcode id="barcode"></canvas>
          </div>
        }
      </div>
      <p class="text-center text-2xl font-bold mt-5">{{ code() }}</p>
      <p class="flex items-center justify-center text-sm text-gray-500 mt-5">
        <img src="/clock.svg" alt="timer" class="w-4 h-4 inline-block mr-2" />
        {{ remaining() | mmss }}
      </p> -->
      <div class="flex flex-col items-center justify-center">
        <h1 class="text-2xl font-bold">BUY 1 GET 1 FREE</h1>
        <p>{{ menuDisplay() }}</p>
        <p>*Payment must be made with Visa card.</p>
      </div>
      <p class="text-center  mt-5">
        Show your "coupon code" to the cashier,

        <br />
        and tap redeem to enjoy your offer.
      </p>
      <div class="flex items-center justify-center">
        <div class="bg-main-blue text-white px-5 py-2.5  mt-5">
          <p class="text-center text-3xl font-semibold tracking-wider">{{ code() }}</p>
        </div>
      </div>
      <button
        class="bg-main-blue text-white px-4 py-2 rounded-md w-full mt-10"
        (click)="onConfirm()"
      >
        Redeem
      </button>
    </div>
  `,
})
export class Showcode implements OnChanges {
  @Input() merchantName: MerchantEnum;

  barcodeCanvas = viewChild<ElementRef<HTMLCanvasElement>>('barcode');
  tabs = [
    {
      label: 'QR Code',
      value: 'qrcode',
    },
    {
      label: 'barcode',
      value: 'code',
    },
  ];

  barcodeWidth = signal(0);
  remaining = signal(0);
  code = signal<string | null>(null);
  selectedTab = signal<string>('qrcode');
  private sub = new Subscription();
  isBarcodeLoading = signal(false);
  private redeemWindow = inject(RedeemWindow);
  private router = inject(Router);
  private merchantContext = inject(MerchantContext);
  merchantKey = computed(() => this.merchantContext.merchantKey());
  menuDisplay = computed(() => {
    switch (this.merchantKey()) {
      case 'JUSTJUICE':
        return 'Strawberry Smoothie (THB 95)';
      case 'JUSTFRUIT':
        return 'Mango Smoothie (THB 95)';
      case 'ITIMLAMOON':
        return 'Watermelon Smoothie (THB 85)';
      case 'MONSOONTEA':
        return 'Jusmin Lime Iced Tea (THB 85)';
      case 'THEPORTTHAI':
        return 'Signature Thai Tea (THB 80)';
      case 'LAFIORE':
        return 'Italian Soda (All Flavors) (THB 95)';
      default:
        return '';
    }
  });

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private changeDetector: ChangeDetectorRef,
  ) {
    const width = this.document.defaultView?.innerWidth;
    this.barcodeWidth.set(width! < 460 ? 1 : width! < 750 ? 2 : 2);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['merchantName']) {
      this.merchantContext.setMerchant(this.merchantName as unknown as string);
    }
  }

  ngOnInit(): void {
    this.sub.add(
      this.redeemWindow.countdown$().subscribe((v) => {
        this.remaining.set(v);
      }),
    );
    this.sub.add(this.redeemWindow.codeId$().subscribe((v) => this.code.set(v)));

    this.sub.add(
      this.redeemWindow
        .countdown$()
        .pipe(
          map((ms) => {
            return ms <= 1;
          }),
          distinctUntilChanged(),
          filter((isZero) => isZero),
          take(1),
        )
        .subscribe(() => {
          this.onConfirm();
        }),
    );
  }

  onSelectTab(tab: string): void {
    this.selectedTab.set(tab);
    if (tab === 'code') {
      this.changeDetector.detectChanges();
      this.generateBarcode();
    }
  }

  async generateBarcode() {
    this.isBarcodeLoading.set(true);
    const canvas = this.barcodeCanvas()?.nativeElement;

    try {
      // Dynamically import bwip-js for browser usage
      // @ts-expect-error - bwip-js types not resolved
      const bwipjs: any = await import('bwip-js');
      const scale = this.dynamicWidth('code128');
      const height = scale > 1 ? 10 : 20;

      // Generate the barcode
      this.isBarcodeLoading.set(false);
      bwipjs.toCanvas(canvas, {
        bcid: 'code128',
        text: this.code(),
        scale: scale,
        height: height,
        includetext: false, // Include human-readable text
        textxalign: 'center',
        textyoffset: 5,
      });

      console.log('Barcode generated successfully!');
    } catch (error) {
      this.isBarcodeLoading.set(false);
      console.error('Error generating barcode:', error);
    }
  }

  dynamicWidth(format: string): number {
    if (!this.code()) return 0;
    if (format === 'code128') {
      if (this.code()?.length <= 15) {
        return this.barcodeWidth() + 1;
      } else {
        return 100;
      }
    } else {
      if (this.code()?.length <= 13) {
        return this.barcodeWidth() + 1;
      } else {
        return this.barcodeWidth();
      }
    }
  }

  onConfirm(): void {
    this.redeemWindow.clear();
    this.router.navigate(['/', this.merchantName], {
      queryParams: {
        redeem: true,
      },
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
